import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router'

import { trackPageLoad } from '../../../mixpanel/mixpanelTracking'
import { expireAlerts } from '../data/alertActions'
import store from '../data/store'

const usePathChanged = () => {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    if (pathname.includes('/python/')) {
      window.location.href = pathname.replace(/(\/python)/g, '')
    }
    trackPageLoad(pathname)

    window.pendo?.pageLoad?.()

    // page is changing, remove alerts that expire on page-change
    store.dispatch(expireAlerts())
  }, [pathname])
}

export default usePathChanged
